import React, { useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import uRLs from "../../baseUtils";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import Convertinvoice from "../../../components/pages/sale/ConvertInvoice";
import InvoiceActionFooter from "../a4Invoices/common/InvoiceActionFooter";
import InvoiceInfoSidebar from "../a4Invoices/common/InvoiceInfoSidebar";
import InvoiceToggleActionCard from "../a4Invoices/common/InvoiceToggleActionCard";
import InvoicePreviewRenderer from "./common/InvoiceHA4PreviewRender";
import PaySettleModal from "./common/PaySettleModal ";
import InvoiceModalLayout from "./common/InvoiceModalLayout ";
import { useInvoiceData } from "./common/useInvoiceData";
import {
  capitalizeFirstLetter,
  loadImageDimensions,
} from "./common/invoiceUtils";
import ReturnSaleInvoice from "../a4Invoices/ReturnSaleInvoice";
import AxiosInstance from "../../AxiosInstance";
import handleError from "../../../constants/handleError";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
const EssentialInvoice = ({
  isData,
  selectedOption,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  isActive,
  optData,
  setOptData,
}) => {
  const invoiceData = useInvoiceData({
    isData,
    onClose,
    onDataUpdate,
    onDataChange,
    optData,
    setOptData,
  });
  const {
    data,
    globalData,
    selectedTheme,
    selectedSize,
    qrCodeDataUrl,
    setSelectedSize,
    terms,
    latestVersion,
    formatTrackMode,
    download,
    setDownload,
    billing,
    setBilling,
    selectTermalOption,
    setSelectTermalOption,
    selectHALFA4Option,
    setSelectHALFA4Option,
    isBtnLoading,
    setBtnLoading,
    isPaySettleModalOpen,
    setIsPaySettleModalOpen,
    isMainModalOpen,
    setIsMainModalOpen,
    saleLoading,
    closeAuto,
    setCloseAuto,
    showConfirm,
    setShowConfirm,
    handleResetSale,
    saleTime,
    storeSettings,
    handleSelectedSale,
    handlelatestSale,
    isBillReceipt,
    documentTitle,
    handleGenerateInvoice,
    handleModeConfirm,
  } = invoiceData;
  const [returnData, setIsReturnData] = useState("");
  const [isReturnView, setIsReturnView] = useState(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const handleClose = () => {
    setIsMainModalOpen(false);
    setIsReturnView(false);
    onClose();
  };

  const handleSelectedReturnSale = async (sale) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setIsReturnData(response.data.results);
      setIsReturnView(true);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const generateBillingPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 7;
    const headerX = 2;
    const headerY = 2;
    const imagePath =
      uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;

    if (globalData?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const addressX = headerX + padding + 95; // right of logo
    let addressY = headerY + 13; // top align with image

    // --- Company Title (dark gray & right-aligned) ---
    doc.setFontSize(8);
    doc.setTextColor(71, 69, 67); // dark gray
    doc.setFont("Inter-Bold", "bold");

    const titleText = String(globalData?.salefrom?.title || "");
    const maxTitleWidth = pageWidth - (addressX - headerX) - 10; // available width
    const titleWidth = doc.getTextWidth(titleText);

    // Right-align title within the available space
    doc.text(titleText, addressX + maxTitleWidth - titleWidth, addressY);
    addressY += 3;

    // --- Address Line 1 ---
    doc.setFontSize(7);
    doc.setFont("Inter-Regular", "normal");
    // black for address

    if (globalData?.salefrom?.addressline1) {
      const lineWidth1 = doc.getTextWidth(globalData?.salefrom?.addressline1);
      doc.text(
        globalData?.salefrom?.addressline1,
        addressX + maxTitleWidth - lineWidth1,
        addressY,
      );
      addressY += 3;
    }

    // --- Address Line 2 ---
    if (globalData?.salefrom?.addressline2) {
      const lineWidth2 = doc.getTextWidth(globalData?.salefrom?.addressline2);
      doc.text(
        globalData?.salefrom?.addressline2,
        addressX + maxTitleWidth - lineWidth2,
        addressY,
      );
      addressY += 3;
    }

    // --- District, State, Country, Pincode + Phone in single line ---
    let combinedLine = [
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.country,
    ]
      .filter(Boolean)
      .join(", ");

    if (globalData?.salefrom?.pincode) {
      combinedLine += ` - ${globalData?.salefrom?.pincode}`;
    }

    // Append phone if exists
    if (globalData?.salefrom?.phone) {
      combinedLine += combinedLine
        ? ` | Ph: ${globalData?.salefrom?.phone}`
        : `Ph: ${globalData?.salefrom?.phone}`;
    }

    // Right-align combined line
    if (combinedLine) {
      const combinedLineWidth = doc.getTextWidth(combinedLine);
      doc.text(
        combinedLine,
        addressX + maxTitleWidth - combinedLineWidth,
        addressY,
      );
      addressY += 3;
    }

    let emailCINLine = "";
    if (globalData?.salefrom?.email) {
      emailCINLine += globalData?.salefrom?.email;
    }
    if (globalData?.salefrom?.cinnumber) {
      emailCINLine += emailCINLine
        ? ` | CIN: ${globalData?.salefrom?.cinnumber}`
        : `CIN: ${globalData?.salefrom?.cinnumber}`;
    }

    if (emailCINLine) {
      const emailCINWidth = doc.getTextWidth(emailCINLine);
      doc.text(
        emailCINLine,
        addressX + maxTitleWidth - emailCINWidth,
        addressY,
      );
      addressY += 3;
    }

    let GSTFSSAILine = "";
    if (globalData?.salefrom?.gstnumber) {
      GSTFSSAILine += globalData?.salefrom?.gstnumber;
    }
    if (globalData?.salefrom?.fssai) {
      GSTFSSAILine += GSTFSSAILine
        ? ` | FSSAI: ${globalData?.salefrom?.fssai}`
        : `FSSAI: ${globalData?.salefrom?.fssai}`;
    }

    if (GSTFSSAILine) {
      const emailCINWidth = doc.getTextWidth(GSTFSSAILine);
      doc.text(
        GSTFSSAILine,
        addressX + maxTitleWidth - emailCINWidth,
        addressY,
      );
      addressY += 3;
    }
    let State = "";
    if (globalData?.salefrom?.gstnumber) {
      State += globalData?.salefrom?.gstnumber;
    }
    if (globalData?.salefrom?.fssai) {
      State += State
        ? ` | State: ${globalData?.salefrom?.state}`
        : `State: ${globalData?.salefrom?.state} [State Code:${globalData?.salefrom?.statecode}]`;
    }

    if (State) {
      const emailCINWidth = doc.getTextWidth(State);
      doc.text(State, addressX + maxTitleWidth - emailCINWidth, addressY);
      addressY += 3;
    }
    const invoiceFontSize = 16;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText =
      globalData.salemode && formatTrackMode(globalData.salemode);
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    if (globalData.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69);
      doc.setFont("Inter-Bold", "bold");
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }

    // const invoiceFontSize=13;
    // doc.setFont("Inter-Bold", "bold");
    // doc.setFontSize(invoiceFontSize);

    // const textHeightOffset = invoiceFontSize * 0.55;
    // const invoiceTextY = headerY + textHeightOffset;
    // const invoiceX = pageWidth - padding;
    // const invoiceText = data.salemode && formatTrackMode(data.salemode);
    // const saletitleY=invoiceTextY+5
    // doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" })
    // doc.setFontSize(10);
    // doc.text(data.salefrom.title,padding+141,saletitleY)
    // doc.setFont("Inter-Regular", "normal");
    // const rawAddresss = [
    //     data.salefrom?.addressline1,
    //     data.salefrom?.district,
    //     data.salefrom?.country,
    //     data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
    //   ]
    //     .filter(Boolean)
    //     .join(", ");
    // const addressY=saletitleY+5
    // doc.text(rawAddresss,padding+122,addressY)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("Phone :",padding+110,addressY+5)
    // doc.text("Email :",padding+145,addressY+5)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(data?.salefrom?.phone,padding+123,addressY+5)
    // doc.text(data?.salefrom?.email,padding+157,addressY+5)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("GST :",padding+175,addressY+10)
    // doc.text("PAN :",padding+185,addressY+10)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(data.salefrom?.gstnumber,padding+123,addressY+10)
    // doc.text(data?.salefrom?.pannumber,padding+157,addressY+10)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("FSSAI :",padding+154,addressY+15)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(data?.salefrom?.fssai,padding+167,addressY+15)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("State :",padding+135,addressY+20)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(` ${data.salefrom?.state} [ State Code: ${
    //     data.salefrom?.statecode || ""
    //   } ]`,padding+147,addressY+20)

    doc.setFontSize(8);
    const invoiceNoLabel = "Bill No:";
    const invoiceNoValue = globalData.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      globalData.saledate,
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 7;
    const innerGap = 2;
    const invoiceRowY = 39;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;
    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 47;
    const midX = pageWidth / 2;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    const hasSaleToData =
      globalData.saleto &&
      (globalData.saleto.name ||
        globalData.saleto.addressline1 ||
        globalData.saleto.addressline2 ||
        globalData.saleto.district ||
        globalData.saleto.country ||
        globalData.saleto.pincode ||
        globalData.saleto.phone ||
        globalData.saleto.email ||
        globalData.saleto.gstnumber ||
        globalData.saleto.state ||
        globalData.saleto.statecode ||
        globalData.saleto.referenceid);
    if (hasSaleToData && optData?.isCustomerDisplay) {
      doc.text("Bill To:", padding, sectionTop);
      // doc.text("Shipping Address:", midX, sectionTop);
    }
    const hasShippingAddress =
      globalData.saleto?.shippingAddress &&
      (globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2);

    if (hasShippingAddress && optData?.isCustomerDisplay) {
      doc.text("Shipping Address:", midX, sectionTop);
    }
    // doc.text("Bill No :", midX, sectionTop);
    //   doc.text("Date :", midX, sectionTop+5);
    //   doc.setFont("Inter-Regular", "normal");
    //   doc.text(data.saleno,midX+14,sectionTop)
    //   doc.text(invoiceDateValue,midX+11,sectionTop+5)

    doc.setFontSize(8);
    let fromY = sectionTop + 5;
    let toY = sectionTop + 5;
    let fromDetails = [];
    if (hasSaleToData && optData?.isCustomerDisplay) {
      fromDetails = [
        { bold: true, text: globalData.saleto?.name || "-" },
        {
          bold: false,
          text: [
            globalData.saleto?.addressline1,
            globalData?.saleto?.state,
            globalData.saleto?.country,
            globalData.saleto?.pincode ? `- ${globalData.saleto.pincode}` : "",
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(globalData?.saleto?.phone
          ? [{ bold: false, text: `Phone: ${globalData?.saleto?.phone}` }]
          : []),
        ...(globalData?.saleto?.email
          ? [{ bold: false, text: `Email: ${globalData?.saleto?.email}` }]
          : []),
        ...(globalData?.saleto?.referenceid
          ? [
              {
                bold: false,
                text: "Reference No:",
                suffix: ` ${globalData?.saleto.referenceid}`,
              },
            ]
          : []),
        ...(globalData.saleto?.gstnumber
          ? [
              {
                bold: false,
                text: `GST:`,
                suffix: ` ${globalData?.saleto?.gstnumber}`,
              },
            ]
          : []),
        ...(globalData.saleto?.fssai
          ? [
              {
                bold: false,
                text: `FSSAI:`,
                suffix: ` ${globalData.saleto?.fssai || ""}`,
              },
            ]
          : []),
        ...(globalData.saleto?.cinnumber
          ? [
              {
                bold: false,
                text: `CIN:`,
                suffix: ` ${globalData.saleto?.cinnumber || ""}`,
              },
            ]
          : []),

        ...(globalData.saleto?.pannumber
          ? [
              {
                bold: false,
                text: `PAN:`,
                suffix: ` ${globalData.saleto?.pannumber || ""}`,
              },
            ]
          : []),
        ...(globalData?.saleto?.state
          ? [
              {
                bold: false,
                text: `State:`,
                suffix: ` ${globalData?.saleto?.state} [ State Code: ${
                  globalData?.saleto?.statecode || ""
                } ]`,
              },
            ]
          : []),
      ];
    }
    const sectionGap = 12;
    const sectionWidth = (pageWidth - padding * 2 - sectionGap) / 2 + 20;
    const fromAddressWrapWidth = sectionWidth - 30;
    const rawAddress = [
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.country,
      globalData?.salefrom?.pincode ? `- ${globalData?.salefrom.pincode}` : "",
    ]
      .filter(Boolean)
      .join(", ");

    // Wrap address to sectionWidth (same used in renderDetails)
    let wrappedAddress = [];

    // Insert wrapped address lines after the title (index 1)
    wrappedAddress.forEach((line, i) => {
      fromDetails.splice(1 + i, 0, { bold: false, text: line });
    });

    let toDetails = [];
    if (hasSaleToData && optData?.isCustomerDisplay) {
      const shipping = globalData?.saleto?.shippingAddress;

      toDetails = [
        { bold: true, text: globalData.saleto?.name || "-" },
        {
          bold: false,
          text: [
            shipping?.addressline1,
            shipping?.addressline2,
            shipping?.district,
            shipping?.state,
            shipping?.country,
            shipping?.pincode ? `- ${shipping.pincode}` : "",
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(shipping?.phone
          ? [{ bold: false, text: `Phone: ${shipping.phone}` }]
          : []),
        ...(shipping?.email
          ? [{ bold: false, text: `Email: ${shipping.email}` }]
          : []),
      ];
    }
    const wrapText = (text, maxWidth) => doc.splitTextToSize(text, maxWidth);
    const lineHeight = 4;
    const renderDetails = (details, startX, startY) => {
      let y = startY - 2;
      details.forEach(({ bold, text, suffix = "" }) => {
        const fullText = text + suffix;
        const lines = wrapText(fullText, sectionWidth);

        lines.forEach((line, index) => {
          if (index === 0 && suffix && bold) {
            const labelWidth = doc.getTextWidth(text);
            doc.setFont("Inter-Bold", "bold");
            doc.text(text, startX, y);
            doc.setFont("Inter-Regular", "normal");
            doc.text(suffix, startX + labelWidth, y);
          } else {
            doc.setFont(
              bold ? "Inter-Bold" : "Inter-Regular",
              bold ? "bold" : "normal",
            );
            doc.text(line, startX, y);
          }
          y += lineHeight;
        });
      });

      return y;
    };
    if (hasSaleToData && optData?.isCustomerDisplay) {
      fromY = renderDetails(fromDetails, padding, fromY);
    }
    toY = renderDetails(toDetails, midX, toY);

    // 3. Product Table
    const productBody = globalData?.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = item.soldprice;
      const landingCost = item?.lineTotalLandingCost;
      const total = item.lineTotalSoldPrice;
      const details = [
        item.hsnsac ? `HSN/SAC: ${item.hsnsac}` : "",
        item.discount > 0
          ? `MRP: ₹${item.mrp} Discount: ₹${item.discount}`
          : "",
        item.taxpercentage > 0
          ? `Tax: ₹${item.baseprice} @${item.taxpercentage}% = ₹${item.taxamount}`
          : "",
      ]
        .filter(Boolean) // removes empty values
        .join(" "); // separator without commas

      const desc = [
        `${item.title}`,
        [
          item.hsnsac ? `HSN/SAC: ${item.hsnsac}` : null,
          item.discount > 0
            ? `MRP: ₹${CurrencyConverter.toCurrency(
                item.mrp || 0,
                "INR",
              )}  Discount:₹${CurrencyConverter.toCurrency(
                item.discount,
                "INR",
              )}`
            : null,
          item.taxpercentage > 0
            ? `Tax:₹${CurrencyConverter.toCurrency(item.baseprice, "INR")} @${
                item.taxpercentage
              }% = ₹${CurrencyConverter.toCurrency(item.taxamount || 0, "INR")}`
            : null,
        ],
      ].join("\n");

      return [
        i + 1,
        `${item.title}`,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode || ""
            : item?.unitConfig?.primaryUnitCode || "";
          return unitCode || "";
        })()}`,
        `₹${total}`,
      ];
    });
    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "center", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        // content: globalData?.totalqty,
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.grandtotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);
    autoTable(doc, {
      startY: Math.max(fromY, toY),
      head: [["S.No", "Items", "Rate", "Qty", "Total"]],
      body: productBody,
      margin: { left: 6, right: 5 }, // add right margin if needed
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 7,
        halign: "middle",
        cellPadding: 2,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: "#041121",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
        fontStyle: "bold",
        font: "Inter-Bold",
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 10, halign: "center", valign: "middle" },
        1: { cellWidth: 127, halign: "left" },
        2: { cellWidth: 21, halign: "center", valign: "middle" },
        3: { cellWidth: 16, halign: "center", valign: "middle" },
        4: { cellWidth: 22, halign: "center", valign: "middle" },
      },
      willDrawCell: function (data) {
        if (data.column.index === 1 && data.section === "body") {
          const itemIndex = data.row.index;
          const item = data.saleitems?.[itemIndex];
          if (!item) return;

          const x = data.cell.x + 2;
          let y = data.cell.y + 4;
          const lineHeight = 4;
          const currency = CurrencyConverter;

          const lines = [
            { type: "title", text: item.title },
            ...(item.imode === "PRODUCT" && item.note
              ? [{ type: "description", text: item.note }]
              : []),
            ...(item.imode === "SERVICE" && item.description
              ? [{ type: "description", text: item.description }]
              : []),
            ...(item.hasnsac
              ? [{ label: "HSN/SAC:", value: item.hasnsac }]
              : []),
            {
              label: "MRP:",
              value: `₹${currency.toCurrency(item.mrp || 0, "INR")}`,
            },
            {
              label: "Discount:",
              value: `₹${currency.toCurrency(item.discount || 0, "INR")}`,
            },
          ];

          data.cell.text = [];
          lines.forEach((line) => {
            if (line.type === "title") {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(15);
              doc.setTextColor(0, 0, 0);
              doc.text(line.text, x, y);
              doc.setFontSize(9);
            } else {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(9);
              doc.setTextColor(0, 0, 0);
              doc.text(line.label, x, y);
              doc.setFont("Inter-Regular", "normal");
              doc.setTextColor(80, 80, 80);
              doc.text(line.value, x + 32, y);
            }
            y += lineHeight;
          });
        }
      },

      theme: "grid",
    });
    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom.statecode !== globalData?.saleto.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 9,
            valign: "top",
          },
        },
        {
          content: "Grand Total",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${globalData?.grandtotal}`,
          styles: { halign: "center", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: globalData?.amountinwords,
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 9,
          },
        },
        {
          content: "Grand Total (Rounded)",
          styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
        },
        {
          content: `₹${globalData?.grandtotal}`,
          styles: {
            halign: "center",
            valign: "middle",
            fontStyle: "bold",
            fontSize: 10,
          },
        },
      ],
    ];
    const afterProductsY = doc.lastAutoTable?.finalY + 0.4;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 25;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: 6, right: 5 },
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 9,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
      },
      columnStyles: {
        0: { cellWidth: 120 },
        1: { cellWidth: 54, halign: "right" },
        2: { cellWidth: 22, halign: "center", valign: "middle" },
      },
      didParseCell: function (data) {
        if (data.row.index === 0 && isSamePage) {
          data.cell.styles.lineWidth = {
            top: 0,
            right: 0.2,
            bottom: 0.2,
            left: 0.2,
          };
        }
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 10;

    if (parseFloat(globalData?.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(
        `Your Total Discount : ₹${globalData?.totaldiscount}`,
        105,
        currentY,
        { align: "center" },
      );

      currentY += 2; // ONLY if discount exists
    }

    // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (globalData?.onlinePaid > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (globalData?.upiPaid > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (globalData?.balanceDue > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }

    // draw table ONLY if rows exist
    if (paymentRows?.length > 0 && optData?.isPayment) {
      autoTable(doc, {
        startY: currentY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 6 },
        tableWidth: 70,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 2,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 30, halign: "right" },
        },
        theme: "grid",
      });

      currentY = doc.lastAutoTable.finalY + 6;
    } else {
      currentY += 5;
    }
    const leftX = padding;
    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      const qrSize = 28;
      const gap = 10;
      let bankY = currentY;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", leftX, bankY);

      bankY += 5;
      const bankDetails = [];

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI ID",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18; // The gap width where the bold values will start aligning
      let maxTextWidth = doc.getTextWidth("Bank Details");

      bankDetails.forEach((item) => {
        // A. Draw Label (Regular weight, slightly lighter color)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0); // Medium grey
        doc.text(`${item.label} :`, leftX, bankY);

        // B. Draw Value (Bold weight, darker color, perfectly aligned to the right of labels)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

        const completeLineWidth =
          labelWidthOffset + doc.getTextWidth(String(item.value || ""));
        maxTextWidth = Math.max(maxTextWidth, completeLineWidth);

        bankY += 4.5;
      });

      doc.setTextColor(0, 0, 0);

      const qrX = leftX + maxTextWidth + gap;
      const qrY = currentY - 3;

      if (qrCodeDataUrl) {
        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      }
      currentY = Math.max(bankY, qrY + qrSize) + 6;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
      align: "center",
    });
    currentY += 5;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
    if (storeSettings?.negobillBranding) {
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    currentY += 8;

    const contentWidth = pageWidth - padding * 2;

    // 70% for Terms
    const termsWidth = contentWidth * 0.7;

    // 30% for Signature
    const signWidth = contentWidth * 0.3;

    // const leftX = padding;
    const rightX = padding + termsWidth;

    let startY = currentY;
    if (optData?.isRemark && globalData?.remark) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Remark", leftX, startY);
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      ); // e.g. [0, 0, 0] or your theme color
      doc.setLineWidth(0.1);
      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(globalData.remark),
        termsWidth - 8,
      );

      const lineHeight = 4;
      const remarkHeight = remarkLines.length * lineHeight + 6;

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);

      let remarkY = startY + 4;

      remarkLines.forEach((line) => {
        doc.text(line, leftX, remarkY);
        remarkY += lineHeight;
      });

      // Move Terms below Remark
      startY += remarkHeight + 1;
    }
    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", leftX, startY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      const splitTerms = doc.splitTextToSize(terms, termsWidth - 5);
      doc.text(splitTerms, leftX, startY + 4);
    }

    // terms.forEach((text,index) => {

    //   // Auto split long lines to fit page width
    //   const textLines = doc.splitTextToSize(text, doc.internal.pageSize.getWidth() - 20);

    //   // Check page overflow & create a new page if needed
    //   if (textY + lineHeights * textLines.length > doc.internal.pageSize.getHeight() - 20) {
    //     doc.addPage();
    //     textY = 20;
    //   }

    //   // Print bullet + text
    //   doc.text(`${index+1}.${textLines.join("\n")}`, 13, textY);

    //   // Move cursor for next line
    //   textY += lineHeights * textLines.length;
    // });

    const boxTopY = currentY + 3;
    // const boxTopY = footerY + 7;
    const boxHeight = 20;
    const boxLeftX = padding;
    const boxRightX = pageWidth - padding;
    const boxWidth = boxRightX - boxLeftX;
    const boxMidX = boxLeftX + boxWidth / 2;

    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    const titleWidths = doc.getTextWidth("Issued By,Signature");
    doc.text(
      "Issued By,Signature",
      addressX + maxTitleWidth - titleWidths,
      boxTopY,
    );
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text(titleText, addressX + maxTitleWidth - titleWidth - 6, boxTopY + 5);
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        // Convert image URL to base64
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(signimg);

        doc.addImage(
          base64,
          format,
          addressX + maxTitleWidth - titleWidths - 15,
          boxTopY + 7,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }
    // doc.setTextColor(0,0,0)
    // doc.setFontSize(8);
    // doc.setDrawColor(200, 200, 200);
    // doc.setLineWidth(0.2);
    // doc.rect(boxLeftX, boxTopY, boxWidth, boxHeight);
    // doc.line(boxMidX, boxTopY, boxMidX, boxTopY + boxHeight);

    // const startY = boxTopY + 6;
    // const lineHeight2 = 5;
    // const leftContentWidth = boxMidX - boxLeftX - 10;
    // const rightContentWidth = boxRightX - boxMidX - 10;

    // // Left side: Declaration label (bold)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("Declaration:", boxLeftX + 5, startY);

    // // Left side: Declaration text (normal)
    // let declarationText =
    //   "We declare that this bill recipet shows the actual price of the goods described and that all particulars are true and correct.";
    // doc.setFont("Inter-Regular", "normal");
    // const leftLines = doc.splitTextToSize(declarationText, leftContentWidth);
    // leftLines.forEach((line, i) => {
    //   doc.text(line, boxLeftX + 5, startY + (i + 1) * lineHeight2);
    // });

    // // Right side: Small note (right aligned)
    // doc.setFont("Inter-Regular", "normal");
    // let rightText = "* Computer Generated Document No sign Required";
    // const rightLines = doc.splitTextToSize(rightText, rightContentWidth);
    // rightLines.forEach((line, i) => {
    //   doc.text(
    //     line,
    //     boxRightX - 5, // align to the right
    //     startY + i * lineHeight2,
    //     { align: "right" }
    //   );
    // });
    setDownload(false);
    // setPrint(false);
    return doc;
  };
  const invLabel = isBillReceipt ? "Bill No:" : "Invoice No:";
  const invTo = isBillReceipt ? "Bill To:" : "Invoice To:";

  const generateinvoicePDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    // console.log(pageWidth);
    const padding = 7;
    const headerX = 2;
    const headerY = 2;
    const imagePath = globalData?.imagePath;

    if (globalData?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const addressX = headerX + padding + 95; // right of logo
    let addressY = headerY + 13; // top align with image

    // --- Company Title (dark gray & right-aligned) ---
    doc.setFontSize(8);
    doc.setTextColor(71, 69, 67); // dark gray
    doc.setFont("Inter-Bold", "bold");

    const titleText = String(globalData?.salefrom?.title || "");
    const maxTitleWidth = pageWidth - (addressX - headerX) - 10; // available width
    const titleWidth = doc.getTextWidth(titleText);

    // Right-align title within the available space
    doc.text(titleText, addressX + maxTitleWidth - titleWidth, addressY);
    addressY += 3;

    // --- Address Line 1 ---
    doc.setFontSize(7);
    doc.setFont("Inter-Regular", "normal");
    // black for address

    if (globalData?.salefrom?.addressline1) {
      const lineWidth1 = doc.getTextWidth(globalData?.salefrom?.addressline1);
      doc.text(
        globalData?.salefrom?.addressline1,
        addressX + maxTitleWidth - lineWidth1,
        addressY,
      );
      addressY += 3;
    }

    // --- Address Line 2 ---
    if (globalData?.salefrom?.addressline2) {
      const lineWidth2 = doc.getTextWidth(globalData?.salefrom?.addressline2);
      doc.text(
        globalData?.salefrom?.addressline2,
        addressX + maxTitleWidth - lineWidth2,
        addressY,
      );
      addressY += 3;
    }

    // --- District, State, Country, Pincode + Phone in single line ---
    let combinedLine = [
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.country,
    ]
      .filter(Boolean)
      .join(", ");

    if (globalData?.salefrom?.pincode) {
      combinedLine += ` - ${globalData?.salefrom?.pincode}`;
    }

    // Append phone if exists
    if (globalData?.salefrom?.phone) {
      combinedLine += combinedLine
        ? ` | Ph: ${globalData?.salefrom?.phone}`
        : `Ph: ${globalData?.salefrom?.phone}`;
    }

    // Right-align combined line
    if (combinedLine) {
      const combinedLineWidth = doc.getTextWidth(combinedLine);
      doc.text(
        combinedLine,
        addressX + maxTitleWidth - combinedLineWidth,
        addressY,
      );
      addressY += 3;
    }

    let emailCINLine = "";
    if (globalData?.salefrom?.email) {
      emailCINLine += globalData?.salefrom?.email;
    }
    if (globalData?.salefrom?.cinnumber) {
      emailCINLine += emailCINLine
        ? ` | CIN: ${globalData?.salefrom?.cinnumber}`
        : `CIN: ${globalData?.salefrom?.cinnumber}`;
    }

    if (emailCINLine) {
      const emailCINWidth = doc.getTextWidth(emailCINLine);
      doc.text(
        emailCINLine,
        addressX + maxTitleWidth - emailCINWidth,
        addressY,
      );
      addressY += 3;
    }

    let GSTFSSAILine = "";
    if (globalData?.salefrom?.gstnumber) {
      GSTFSSAILine += `GST :${globalData?.salefrom?.gstnumber}`;
    }
    if (globalData?.salefrom?.fssai) {
      GSTFSSAILine += GSTFSSAILine
        ? ` | FSSAI: ${globalData?.salefrom?.fssai}`
        : `FSSAI: ${globalData?.salefrom?.fssai}`;
    }

    if (GSTFSSAILine) {
      const emailCINWidth = doc.getTextWidth(GSTFSSAILine);
      doc.text(
        GSTFSSAILine,
        addressX + maxTitleWidth - emailCINWidth,
        addressY,
      );
      addressY += 3;
    }
    let State = "";
    // if (data?.salefrom?.gstnumber) {
    //   State += `GST :${data?.salefrom?.gstnumber}`;
    // }
    if (globalData?.salefrom?.fssai) {
      State += State
        ? ` | State: ${globalData?.salefrom?.state}`
        : `State: ${globalData?.salefrom?.state} [State Code:${globalData?.salefrom?.statecode}]`;
    }

    if (State) {
      const emailCINWidth = doc.getTextWidth(State);
      doc.text(State, addressX + maxTitleWidth - emailCINWidth, addressY);
      addressY += 3;
    }
    const invoiceFontSize = 16;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = globalData?.salemode && documentTitle;
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    if (globalData?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69);
      doc.setFont("Inter-Bold", "bold");
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }

    // const invoiceFontSize=13;
    // doc.setFont("Inter-Bold", "bold");
    // doc.setFontSize(invoiceFontSize);

    // const textHeightOffset = invoiceFontSize * 0.55;
    // const invoiceTextY = headerY + textHeightOffset;
    // const invoiceX = pageWidth - padding;
    // const invoiceText = data.salemode && formatTrackMode(data.salemode);
    // const saletitleY=invoiceTextY+5
    // doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" })
    // doc.setFontSize(10);
    // doc.text(data.salefrom.title,padding+141,saletitleY)
    // doc.setFont("Inter-Regular", "normal");
    // const rawAddresss = [
    //     data.salefrom?.addressline1,
    //     data.salefrom?.district,
    //     data.salefrom?.country,
    //     data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
    //   ]
    //     .filter(Boolean)
    //     .join(", ");
    // const addressY=saletitleY+5
    // doc.text(rawAddresss,padding+122,addressY)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("Phone :",padding+110,addressY+5)
    // doc.text("Email :",padding+145,addressY+5)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(data?.salefrom?.phone,padding+123,addressY+5)
    // doc.text(data?.salefrom?.email,padding+157,addressY+5)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("GST :",padding+175,addressY+10)
    // doc.text("PAN :",padding+185,addressY+10)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(data.salefrom?.gstnumber,padding+123,addressY+10)
    // doc.text(data?.salefrom?.pannumber,padding+157,addressY+10)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("FSSAI :",padding+154,addressY+15)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(data?.salefrom?.fssai,padding+167,addressY+15)
    // doc.setFont("Inter-Bold", "bold");
    // doc.text("State :",padding+135,addressY+20)
    // doc.setFont("Inter-Regular", "normal");
    // doc.text(` ${data.salefrom?.state} [ State Code: ${
    //     data.salefrom?.statecode || ""
    //   } ]`,padding+147,addressY+20)

    doc.setFontSize(8);
    const invoiceNoLabel = invLabel;
    const invoiceNoValue = globalData?.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      globalData?.saledate,
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 7;
    const innerGap = 2;
    const invoiceRowY = 39;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;
    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );

    const sectionTop = 47;
    const midX = pageWidth / 2;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    const hasSaleToData =
      globalData?.saleto &&
      (globalData?.saleto?.name ||
        globalData?.saleto?.addressline1 ||
        globalData?.saleto?.addressline2 ||
        globalData?.saleto?.district ||
        globalData?.saleto?.country ||
        globalData?.saleto?.pincode ||
        globalData?.saleto?.phone ||
        globalData?.saleto?.email ||
        globalData?.saleto?.gstnumber ||
        globalData?.saleto?.state ||
        globalData?.saleto?.statecode ||
        globalData?.saleto?.referenceid);
    if (hasSaleToData && optData?.isCustomerDisplay) {
      doc.text(invTo, padding, sectionTop);
      // doc.text("Shipping Address:", midX, sectionTop);
    }
    const hasShippingAddress =
      globalData.saleto?.shippingAddress &&
      (globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2);

    if (hasShippingAddress && optData?.isCustomerDisplay) {
      doc.text("Shipping Address:", midX, sectionTop);
    }
    //   doc.text("Bill No :", midX, sectionTop);
    //   doc.text("Date :", midX, sectionTop+5);
    //   doc.setFont("Inter-Regular", "normal");
    //   doc.text(data.saleno,midX+14,sectionTop)
    //   doc.text(invoiceDateValue,midX+11,sectionTop+5)

    doc.setFontSize(8);
    let fromY = sectionTop + 5;
    let toY = sectionTop + 5;
    let fromDetails = [];
    if (hasSaleToData && optData?.isCustomerDisplay) {
      fromDetails = [
        { bold: true, text: globalData.saleto?.name || "-" },
        {
          bold: false,
          text: [
            globalData.saleto?.addressline1,
            globalData?.saleto?.state,
            globalData.saleto?.country,
            globalData.saleto?.pincode ? `- ${globalData.saleto.pincode}` : "",
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(globalData?.saleto?.phone
          ? [{ bold: false, text: `Phone: ${globalData?.saleto?.phone}` }]
          : []),
        ...(globalData?.saleto?.email
          ? [{ bold: false, text: `Email: ${globalData?.saleto?.email}` }]
          : []),
        ...(globalData.saleto?.referenceid
          ? [
              {
                bold: false,
                text: "Reference No:",
                suffix: ` ${globalData.saleto.referenceid}`,
              },
            ]
          : []),
        ...(globalData?.saleto?.gstnumber
          ? [
              {
                bold: false,
                text: `GST:`,
                suffix: ` ${globalData?.saleto?.gstnumber}`,
              },
            ]
          : []),
        ...(globalData.saleto?.fssai
          ? [
              {
                bold: false,
                text: `FSSAI:`,
                suffix: ` ${globalData.saleto?.fssai || ""}`,
              },
            ]
          : []),
        ...(globalData.saleto?.cinnumber
          ? [
              {
                bold: false,
                text: `CIN:`,
                suffix: ` ${globalData.saleto?.cinnumber || ""}`,
              },
            ]
          : []),

        ...(globalData.saleto?.pannumber
          ? [
              {
                bold: false,
                text: `PAN:`,
                suffix: ` ${globalData.saleto?.pannumber || ""}`,
              },
            ]
          : []),
        ...(globalData?.saleto?.state
          ? [
              {
                bold: false,
                text: `State:`,
                suffix: ` ${globalData?.saleto?.state} [ State Code: ${
                  globalData?.saleto?.statecode || ""
                } ]`,
              },
            ]
          : []),
      ];
    }
    const sectionGap = 12;
    const sectionWidth = (pageWidth - padding * 2 - sectionGap) / 2 + 20;
    const fromAddressWrapWidth = sectionWidth - 30;
    const rawAddress = [
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.country,
      globalData?.salefrom?.pincode ? `- ${globalData.salefrom.pincode}` : "",
    ]
      .filter(Boolean)
      .join(", ");

    // Wrap address to sectionWidth (same used in renderDetails)
    let wrappedAddress = [];

    // Insert wrapped address lines after the title (index 1)
    wrappedAddress.forEach((line, i) => {
      fromDetails.splice(1 + i, 0, { bold: false, text: line });
    });

    let toDetails = [];
    if (hasSaleToData && optData?.isCustomerDisplay) {
      const shipping = globalData?.saleto?.shippingAddress;

      toDetails = [
        { bold: true, text: globalData.saleto?.name || "-" },
        {
          bold: false,
          text: [
            shipping?.addressline1,
            shipping?.addressline2,
            shipping?.district,
            shipping?.state,
            shipping?.country,
            shipping?.pincode ? `- ${shipping.pincode}` : "",
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(shipping?.phone
          ? [{ bold: false, text: `Phone: ${shipping.phone}` }]
          : []),
        ...(shipping?.email
          ? [{ bold: false, text: `Email: ${shipping.email}` }]
          : []),
      ];
    }
    const wrapText = (text, maxWidth) => doc.splitTextToSize(text, maxWidth);
    const lineHeight = 4;
    const renderDetails = (details, startX, startY) => {
      let y = startY - 2;
      details.forEach(({ bold, text, suffix = "" }) => {
        const fullText = text + suffix;
        const lines = wrapText(fullText, sectionWidth);

        lines.forEach((line, index) => {
          if (index === 0 && suffix && bold) {
            const labelWidth = doc.getTextWidth(text);
            doc.setFont("Inter-Bold", "bold");
            doc.text(text, startX, y);
            doc.setFont("Inter-Regular", "normal");
            doc.text(suffix, startX + labelWidth, y);
          } else {
            doc.setFont(
              bold ? "Inter-Bold" : "Inter-Regular",
              bold ? "bold" : "normal",
            );
            doc.text(line, startX, y);
          }
          y += lineHeight;
        });
      });

      return y;
    };
    if (hasSaleToData && optData?.isCustomerDisplay) {
      fromY = renderDetails(fromDetails, padding, fromY);
    }
    toY = renderDetails(toDetails, midX, toY);

    // 3. Product Table
    const productBody = globalData?.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const hsn = item.hsnsac;
      const landingCost = item?.lineTotalLandingCost;
      const mrp = item.mrp;
      const gst = `${item.taxpercentage}%`;
      const rate = item.soldprice;
      const discount = `₹${item.discount}`;
      const total = item.lineTotalSoldPrice;
      const details = [
        item.hsnsac ? `HSN/SAC: ${item.hsnsac}` : "",
        item.discount > 0
          ? `MRP: ₹${item.mrp} Discount: ₹${item.discount}`
          : "",
        item.taxpercentage > 0
          ? `Tax: ₹${item.baseprice} @${item.taxpercentage}% = ₹${item.taxamount}`
          : "",
      ]
        .filter(Boolean) // removes empty values
        .join(" "); // separator without commas

      const desc = [
        `${item.title}`,
        [
          item.hsnsac ? `HSN/SAC: ${item.hsnsac}` : null,
          item.discount > 0
            ? `MRP: ₹${CurrencyConverter.toCurrency(
                item.mrp || 0,
                "INR",
              )}  Discount:₹${CurrencyConverter.toCurrency(
                item.discount,
                "INR",
              )}`
            : null,
          item.taxpercentage > 0
            ? `Tax:₹${CurrencyConverter.toCurrency(item.baseprice, "INR")} @${
                item.taxpercentage
              }% = ₹${CurrencyConverter.toCurrency(item.taxamount || 0, "INR")}`
            : null,
        ],
      ].join("\n");

      return [
        i + 1,
        `${item.title}`,
        hsn,
        `₹${mrp}`,
        gst,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode
            : item?.unitConfig?.primaryUnitCode;
          return unitCode  || "";
        })()}`,
        discount,
        `₹${total}`,
      ];
    });
    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 4,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        colSpan: 2,
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },

      {
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.totaldiscount}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.grandtotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);
    autoTable(doc, {
      startY: Math.max(fromY, toY),
      head: [
        [
          "S.No",
          "Items",
          "HSN/SAC",
          "MRP",
          "GST",
          "Rate",
          "Qty",
          "Disc",
          "Total",
        ],
      ],
      body: productBody,
      margin: { left: 6, right: 5 }, // add right margin if needed
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 7,
        halign: "middle",
        cellPadding: 2,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.1,
        textColor: "#041121",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        fontStyle: "bold",
        font: "Inter-Bold",
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 7, halign: "center", valign: "middle" },
        1: { cellWidth: 79, halign: "left" },
        2: { cellWidth: 17, halign: "center", valign: "middle" },
        3: { cellWidth: 18, halign: "center", valign: "middle" },
        4: { cellWidth: 10, halign: "center", valign: "middle" },
        5: { cellWidth: 18, halign: "center", valign: "middle" },
        6: { cellWidth: 13, halign: "center", valign: "middle" },
        7: { cellWidth: 17, halign: "center", valign: "middle" },
        8: { cellWidth: 17, halign: "center", valign: "middle" },
      },
      willDrawCell: function (data) {
        if (data.column.index === 1 && data.section === "body") {
          const itemIndex = data.row.index;
          const item = data.saleitems?.[itemIndex];
          if (!item) return;

          const x = data.cell.x + 2;
          let y = data.cell.y + 4;
          const lineHeight = 4;
          const currency = CurrencyConverter;

          const lines = [
            { type: "title", text: item.title },
            ...(item.imode === "PRODUCT" && item.note
              ? [{ type: "description", text: item.note }]
              : []),
            ...(item.imode === "SERVICE" && item.description
              ? [{ type: "description", text: item.description }]
              : []),
            ...(item.hasnsac
              ? [{ label: "HSN/SAC:", value: item.hasnsac }]
              : []),
            {
              label: "MRP:",
              value: `₹${currency.toCurrency(item.mrp || 0, "INR")}`,
            },
            {
              label: "Discount:",
              value: `₹${currency.toCurrency(item.discount || 0, "INR")}`,
            },
          ];

          data.cell.text = [];
          lines.forEach((line) => {
            if (line.type === "title") {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(15);
              doc.setTextColor(0, 0, 0);
              doc.text(line.text, x, y);
              doc.setFontSize(9);
            } else {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(9);
              doc.setTextColor(0, 0, 0);
              doc.text(line.label, x, y);
              doc.setFont("Inter-Regular", "normal");
              doc.setTextColor(80, 80, 80);
              doc.text(line.value, x + 32, y);
            }
            y += lineHeight;
          });
        }
      },

      theme: "grid",
    });
    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom.statecode !== globalData?.saleto.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 8,
            valign: "top",
          },
        },
        {
          content: "Grand Total",
          styles: { halign: "right", fontSize: 8 },
        },
        {
          content: `₹${globalData?.grandtotal}`,
          styles: { halign: "center", valign: "middle", fontSize: 8 },
        },
      ],
      [
        {
          content: globalData?.amountinwords,
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
        },
        {
          content: "Grand Total (Rounded)",
          styles: { fontStyle: "bold", halign: "right", fontSize: 8 },
        },
        {
          content: `₹${globalData?.grandtotal}`,
          styles: {
            halign: "center",
            valign: "middle",
            fontStyle: "bold",
            fontSize: 8.5,
          },
        },
      ],
    ];
    const afterProductsY = doc.lastAutoTable?.finalY + 0.4;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 25;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: 6, right: 5 },
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 9,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
      },
      columnStyles: {
        0: { cellWidth: 104 },
        1: { cellWidth: 74, halign: "right" },
        2: { cellWidth: 18, halign: "center", valign: "middle" },
      },
      didParseCell: function (data) {
        if (data.row.index === 0 && isSamePage) {
          data.cell.styles.lineWidth = {
            top: 0,
            right: 0.2,
            bottom: 0.2,
            left: 0.2,
          };
        }
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 10;

    if (parseFloat(globalData?.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(
        `Your Total Discount : ₹${globalData?.totaldiscount}`,
        105,
        currentY,
        { align: "center" },
      );

      currentY += 2; // ONLY if discount exists
    }
    // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------
    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (globalData?.onlinePaid > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (globalData?.upiPaid > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (globalData?.balanceDue > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }

    // draw table ONLY if rows exist
    if (paymentRows?.length > 0 && optData?.isPayment) {
      autoTable(doc, {
        startY: currentY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 6 },
        tableWidth: 70,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 2,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 30, halign: "right" },
        },
        theme: "grid",
      });

      currentY = doc.lastAutoTable.finalY + 6;
    } else {
      currentY += 5;
    }
    const leftX = padding;
    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      const qrSize = 28;
      const gap = 10;
      let bankY = currentY;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", leftX, bankY);

      bankY += 5;
      const bankDetails = [];

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI ID",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18; // The gap width where the bold values will start aligning
      let maxTextWidth = doc.getTextWidth("Bank Details");

      bankDetails.forEach((item) => {
        // A. Draw Label (Regular weight, slightly lighter color)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0); // Medium grey
        doc.text(`${item.label} :`, leftX, bankY);

        // B. Draw Value (Bold weight, darker color, perfectly aligned to the right of labels)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

        const completeLineWidth =
          labelWidthOffset + doc.getTextWidth(String(item.value || ""));
        maxTextWidth = Math.max(maxTextWidth, completeLineWidth);

        bankY += 4.5;
      });

      doc.setTextColor(0, 0, 0);

      const qrX = leftX + maxTextWidth + gap;
      const qrY = currentY - 3;

      if (qrCodeDataUrl) {
        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      }
      currentY = Math.max(bankY, qrY + qrSize) + 6;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
      align: "center",
    });
    currentY += 5;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
    if (storeSettings?.negobillBranding) {
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    currentY += 8;

    const contentWidth = pageWidth - padding * 2;

    // 70% for Terms
    const termsWidth = contentWidth * 0.7;

    // 30% for Signature
    const signWidth = contentWidth * 0.3;

    // const leftX = padding;
    const rightX = padding + termsWidth;

    let startY = currentY;
    if (optData?.isRemark && globalData?.remark) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Remark", leftX, startY);
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      ); // e.g. [0, 0, 0] or your theme color
      doc.setLineWidth(0.1);
      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(globalData.remark),
        termsWidth - 8,
      );

      const lineHeight = 4;
      const remarkHeight = remarkLines.length * lineHeight + 6;

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);

      let remarkY = startY + 4;

      remarkLines.forEach((line) => {
        doc.text(line, leftX, remarkY);
        remarkY += lineHeight;
      });

      // Move Terms below Remark
      startY += remarkHeight + 1;
    }

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", leftX, startY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      const splitTerms = doc.splitTextToSize(terms, termsWidth - 5);
      doc.text(splitTerms, leftX, startY + 4);
    }

    const boxTopY = currentY + 3;
    // const boxTopY = footerY + 7;
    const boxHeight = 20;
    const boxLeftX = padding;
    const boxRightX = pageWidth - padding;
    const boxWidth = boxRightX - boxLeftX;
    const boxMidX = boxLeftX + boxWidth / 2;

    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    const titleWidths = doc.getTextWidth("Issued By,Signature");
    doc.text(
      "Issued By,Signature",
      addressX + maxTitleWidth - titleWidths,
      boxTopY,
    );
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text(titleText, addressX + maxTitleWidth - titleWidth - 6, boxTopY + 4);
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        // Convert image URL to base64
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(signimg);

        doc.addImage(
          base64,
          format,
          addressX + maxTitleWidth - titleWidths - 15,
          boxTopY + 6,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    setDownload(false);
    // setPrint(false);
    return doc;
  };

  if (isReturnView) {
    return (
      <ReturnSaleInvoice
        isData={returnData} // This is the updated return sale data loaded by your hook
        selectedOption={selectedOption}
        onClose={handleClose}
        saleId={isData?._id}
        onDataUpdate={onDataUpdate}
        onDataChange={onDataChange}
        isActive={isActive}
      />
    );
  }
  return (
    <>
      <InvoiceModalLayout
        isOpen={isMainModalOpen}
        data={data}
        latestVersion={latestVersion}
        isBtnLoading={isBtnLoading}
        handleResetSale={handleResetSale}
        handleModeConfirm={handleModeConfirm}
        generateInvoice1={generateinvoicePDF}
        generateBill1={generateBillingPDF}
        onClose={handleClose}
        {...invoiceData}
      >
        <InvoiceToggleActionCard
          optData={optData}
          setOptData={setOptData}
          setBilling={setBilling}
          setSelectTermalOption={setSelectTermalOption}
          setSelectHALFA4Option={setSelectHALFA4Option}
        />
        {saleLoading ? (
          <div
            className="d-flex justify-content-center"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            <CircularProgress size={20} className="text-primary" />
          </div>
        ) : (
          <div
            className="pt-2"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            {globalData.salemode === "INVOICE" || isBillReceipt ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <td width="40%" style={{ textAlign: "left" }}>
                                  <div className="tm_logo">
                                    {globalData?.salefrom?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          globalData?.salefrom?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="50"
                                      />
                                    )}
                                  </div>
                                </td>
                                <td width="60%" style={{ textAlign: "right" }}>
                                  <div className="tm_primary_color fs-5 tm_text_uppercase">
                                    {globalData.salemode && (
                                      <>{documentTitle}</>
                                    )}
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {globalData.salefrom?.title || ""}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "18px",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      <div>
                                        {globalData.salefrom?.addressline1 ||
                                          ""}{" "}
                                      </div>
                                      <div>
                                        {globalData.salefrom?.addressline2 ||
                                          ""}{" "}
                                      </div>
                                      <div>
                                        {globalData.salefrom?.district || ""}{" "}
                                        {globalData.salefrom?.state || ""}{" "}
                                        {globalData.salefrom?.country || ""} -{" "}
                                        {globalData.salefrom?.pincode || ""}
                                        Phone:+91{" "}
                                        {globalData.salefrom?.phone || "-"}{" "}
                                      </div>
                                      <div>
                                        Email:{" "}
                                        {globalData.salefrom?.email || "-"}
                                      </div>
                                      {/* <div>
                                        <strong>GST:</strong>{" "}
                                        {data.salefrom?.gstnumber || "-"}{" "}
                                        <strong>PAN:</strong>{" "}
                                        {data.salefrom?.pannumber || "-"}
                                      </div> */}

                                      <div>
                                        {globalData.salefrom?.gstnumber && (
                                          <>
                                            GST:{" "}
                                            {globalData.salefrom?.gstnumber}{" "}
                                            |{" "}
                                          </>
                                        )}
                                        {globalData.salefrom?.fssai && (
                                          <>
                                            FSSAI: {globalData.salefrom?.fssai}
                                          </>
                                        )}
                                      </div>

                                      <div>
                                        State:{" "}
                                        {globalData.salefrom?.state || ""} [
                                        State Code:{" "}
                                        {globalData.salefrom?.statecode || ""} ]
                                      </div>
                                    </div>
                                  </div>
                                  {globalData.status === "CANCELLED" && (
                                    <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                      {globalData.status}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="tm_invoice_info tm_mb20">
                            <div
                              className="tm_invoice_seperator tm_gray_bg"
                              style={{
                                backgroundColor:
                                  selectedTheme?.templateTheme?.primaryColor,
                              }}
                            ></div>
                            <div className="tm_invoice_info_list">
                              <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                                <b className="tm_primary_color">{invLabel} </b>{" "}
                                {globalData.saleno}
                              </p>
                              <p className="tm_invoice_date tm_m0 mt-3">
                                <b className="tm_primary_color"> Date: </b>{" "}
                                {saleTime.date}
                              </p>
                            </div>
                          </div>
                          {optData?.isCustomerDisplay && (
                            <table width="100%" className="pdfcontent">
                              <tbody>
                                <tr>
                                  <td
                                    width="45%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {globalData.saleto &&
                                      (globalData.saleto.name ||
                                        globalData.saleto.addressline1 ||
                                        globalData.saleto.addressline2 ||
                                        globalData.saleto.state ||
                                        globalData.saleto.district ||
                                        globalData.saleto.country ||
                                        globalData.saleto.pincode ||
                                        globalData.saleto.phone ||
                                        globalData.saleto.email ||
                                        globalData.saleto.gstnumber ||
                                        globalData.saleto.statecode ||
                                        globalData.saleto.referenceid) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {invTo}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {globalData.saleto?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {globalData.saleto
                                                ?.addressline1 || ""}{" "}
                                              {/* {globalData.saleto?.addressline2 || ""}{" "} */}
                                              {globalData.saleto?.state || ""}{" "}
                                              {globalData.saleto?.district ||
                                                ""}{" "}
                                              {globalData.saleto?.country || ""}{" "}
                                              -{" "}
                                              {globalData.saleto?.pincode || ""}
                                            </div>
                                            {globalData.saleto?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {globalData.saleto?.phone}
                                              </div>
                                            )}
                                            {globalData.saleto?.email && (
                                              <div>
                                                Email:{" "}
                                                {globalData.saleto?.email}
                                              </div>
                                            )}
                                            {globalData.saleto?.referenceid && (
                                              <div>
                                                Reference No:{" "}
                                                {globalData.saleto?.referenceid}
                                              </div>
                                            )}
                                            {globalData.saleto?.gstnumber && (
                                              <div>
                                                GST:{" "}
                                                {globalData.saleto?.gstnumber}
                                              </div>
                                            )}
                                            {globalData.saleto?.fssai && (
                                              <div>
                                                FASSI:{" "}
                                                {globalData.saleto?.fssai}
                                              </div>
                                            )}
                                            {globalData.saleto?.cinnumber && (
                                              <div>
                                                CIN:{" "}
                                                {globalData.saleto?.cinnumber}
                                              </div>
                                            )}
                                            {globalData.saleto?.pannumber && (
                                              <div>
                                                PAN:{" "}
                                                {globalData.saleto?.pannumber}
                                              </div>
                                            )}
                                            {globalData.saleto?.state && (
                                              <div>
                                                State:{" "}
                                                {globalData.saleto?.state} [
                                                State Code :
                                                {globalData.saleto?.statecode ||
                                                  ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </td>

                                  <td width="10%"></td>

                                  <td
                                    width="45%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {globalData.saleto?.shippingAddress &&
                                      (globalData.saleto?.shippingAddress
                                        ?.addressline1 ||
                                        globalData.saleto?.shippingAddress
                                          ?.addressline2) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            Shipping Address:
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {globalData.saleto?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {globalData.saleto
                                                ?.shippingAddress
                                                ?.addressline1 || ""}{" "}
                                              {/* {globalData.saleto?.shippingAddress?.addressline2 || ""}{" "} */}
                                              {globalData.saleto
                                                ?.shippingAddress?.state ||
                                                ""}{" "}
                                              {globalData.saleto
                                                ?.shippingAddress?.district ||
                                                ""}{" "}
                                              {globalData.saleto
                                                ?.shippingAddress?.country ||
                                                ""}{" "}
                                              -{" "}
                                              {globalData.saleto
                                                ?.shippingAddress?.pincode ||
                                                ""}
                                            </div>
                                            {globalData.saleto?.shippingAddress
                                              ?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {
                                                  globalData.saleto
                                                    ?.shippingAddress?.phone
                                                }
                                              </div>
                                            )}
                                            {globalData.saleto?.shippingAddress
                                              ?.email && (
                                              <div>
                                                Email:{" "}
                                                {
                                                  globalData.saleto
                                                    ?.shippingAddress?.email
                                                }
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    {/* <div>
                                    <p className="tm_invoice_number tm_m0 mb-0 mt-1">
                                      <b className="tm_primary_color">
                                        Bill No:{" "}
                                      </b>{" "}
                                      {data.saleno}
                                    </p>
                                  </div> */}
                                    {/* <div>
                                        <p className="tm_invoice_date tm_m0 mt-1">
                                        <b className="tm_primary_color">
                                            {" "}
                                            Date:{" "}
                                        </b>{" "}
                                        {saleTime.date}
                                        </p>
                                    </div> */}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )}
                          <table
                            // className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Items
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  HSN/SAC
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  MRP
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  GST
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Qty
                                </th>

                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Disc
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {globalData.saleitems?.map((product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "5%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "65%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    <div>{product.title}</div>
                                    {/* {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fs-12 text-truncate-description text-muted">
                                          {product?.note}
                                        </div>
                                      )} */}

                                    {/* <div>
                                      {product.hsnsac && (
                                        <span>
                                          <span className="fw-medium">
                                            HSN/SAC :{" "}
                                          </span>{" "}
                                          {product.hsnsac}
                                        </span>
                                      )}
                                      {product.discount > 0 && (
                                        <>
                                          <>
                                            {" "}
                                            <span className="fw-medium">
                                              MRP :{" "}
                                            </span>{" "}
                                            ₹
                                            {CurrencyConverter.toCurrency(
                                              product.mrp || 0,
                                              "INR"
                                            )}
                                          </>{" "}
                                          <>
                                            <span className="fw-medium">
                                              Discount :{" "}
                                            </span>{" "}
                                             ₹
                                            {CurrencyConverter.toCurrency(
                                              product.discount || 0,
                                              "INR"
                                            )}
                                          </>
                                        </>
                                      )}{" "}
                                      {product.taxpercentage > 0 && (
                                        <>
                                          <span className="fw-medium">
                                            Tax :{" "}
                                          </span>{" "}
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            product.baseprice || 0,
                                            "INR"
                                          )}
                                          @{product.taxpercentage}% = ₹
                                          {CurrencyConverter.toCurrency(
                                            product.taxamount || 0,
                                            "INR"
                                          )}
                                        </>
                                      )}
                                    </div> */}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product.hsnsac}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.mrp}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "7%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product.taxpercentage}%
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.soldprice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode || "";
                                      })()}
                                    </span>
                                  </td>

                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.discount}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.lineTotalSoldPrice}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td
                                  colSpan={4}
                                  className="force-style"
                                  style={{
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                ></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan={2}
                                >
                                  Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  {/* {globalData.totalqty} */}
                                </td>

                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  {globalData?.totaldiscount > 0
                                    ? `₹${globalData.totaldiscount}`
                                    : "-"}
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  ₹{globalData.totalsoldprice}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="4"
                                >
                                  Total Amount In Words
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="4"
                                >
                                  Grand Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  ₹{globalData.grandtotal}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    // "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                    // "--th-color": selectedTheme?.templateTheme?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="4"
                                  rowSpan="5"
                                >
                                  {globalData.amountinwords}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="4"
                                >
                                  Grand Total (Rounded)
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  ₹{globalData.grandtotal}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    padding: "8px",
                                  }}
                                >
                                  Your Total Discount : ₹
                                  {globalData.totaldiscount}
                                  {/* <br />
                                    <div className="mt-1 fs-20">
                                      <span
                                      >
                                        ***** Thank You! Visit Us Again *****
                                      </span>
                                    </div> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          {globalData?.grandtotal > 0 && optData?.isPayment && (
                            <table
                              className="items"
                              width="38%"
                              style={{
                                marginTop: "4px",
                                // borderCollapse: "collapse",
                              }}
                              cellPadding="4"
                            >
                              <thead>
                                <tr>
                                  <th
                                    colSpan={2}
                                    className="force-style"
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      "--th-bg":
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                      "--th-color":
                                        selectedTheme?.templateTheme
                                          ?.foregroundColor,
                                    }}
                                  >
                                    Payment Mode
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {(globalData?.cashamount || 0) -
                                  (globalData?.cashchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Cash
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.cashPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.cardamount || 0) -
                                  (globalData?.cardchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Card
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.cardPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.onlineamount || 0) -
                                  (globalData?.onlinechange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      OnlineAmount
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.onlinePaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.upiamount || 0) -
                                  (globalData?.upichange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      UPI
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.upiPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.paylateramount || 0) -
                                  (globalData?.paylaterchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      BalanceDue
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.balanceDue}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                          <div className="row mt-2">
                            <div className="col-3 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl && optData?.isBankDetails && (
                              <div className="col-3 d-flex align-items-center justify-content-end">
                                <img
                                  src={qrCodeDataUrl}
                                  alt="QR"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="mt-2 fs-20 d-flex justify-content-center fw-bold">
                            <span>***** Thank You! Visit Us Again *****</span>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div className="mt-1 fs-20 d-flex justify-content-center fw-bold">
                                <span>Powered By</span>
                              </div>
                              <div className=" fs-20 d-flex justify-content-center fw-bold">
                                <span>www.NegoBill.com</span>
                              </div>
                            </>
                          )}
                          <table width="100%">
                            <tbody>
                              <tr>
                                {/* Left */}
                                <td
                                  width="70%"
                                  style={{
                                    verticalAlign: "top",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {optData?.isRemark && globalData?.remark ? (
                                    <>
                                      <div className="font-12 fw-600 text-black mb-1">
                                        Remark
                                      </div>

                                      <div
                                        className="font-12 mb-2 p-0"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {capitalizeFirstLetter(
                                          globalData?.remark,
                                        )}
                                      </div>
                                    </>
                                  ) : null}

                                  {terms?.length > 0 && (
                                    <>
                                      <div
                                        className="fs-13 fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>

                                      <div className="terms-box">{terms}</div>
                                    </>
                                  )}
                                </td>

                                {/* Right */}
                                <td
                                  width="30%"
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings.invoiceSettings.signature
                                      }
                                      width={150}
                                      alt="Signature"
                                    />
                                  )}

                                  <div>Issued By, Signature</div>

                                  <div className="fw-bold">
                                    {globalData?.salefrom?.title}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : globalData.salemode === "BILL" ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <td width="40%" style={{ textAlign: "left" }}>
                                  <div className="tm_logo">
                                    {globalData?.salefrom?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          globalData?.salefrom?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="50"
                                      />
                                    )}
                                  </div>
                                </td>
                                <td width="60%" style={{ textAlign: "right" }}>
                                  <div className="tm_primary_color fs-5 tm_text_uppercase">
                                    {globalData?.salemode &&
                                      formatTrackMode(globalData?.salemode)}
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {globalData?.salefrom?.title || ""}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "18px",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      <div>
                                        {globalData?.salefrom?.addressline1 ||
                                          ""}{" "}
                                      </div>
                                      <div>
                                        {globalData?.salefrom?.addressline2 ||
                                          ""}{" "}
                                      </div>
                                      <div>
                                        {globalData?.salefrom?.district || ""}{" "}
                                        {globalData?.salefrom?.state || ""}{" "}
                                        {globalData?.salefrom?.country || ""} -{" "}
                                        {globalData?.salefrom?.pincode || ""}
                                        Phone:+91{" "}
                                        {globalData?.salefrom?.phone ||
                                          "-"}{" "}
                                      </div>
                                      <div>
                                        Email:{" "}
                                        {globalData?.salefrom?.email || "-"}
                                      </div>
                                      {/* <div>
                                        <strong>GST:</strong>{" "}
                                        {globalData?.salefrom?.gstnumber || "-"}{" "}
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.salefrom?.pannumber || "-"}
                                      </div> */}
                                      {globalData?.salefrom?.fssai && (
                                        <div>
                                          FSSAI: {globalData?.salefrom?.fssai}
                                        </div>
                                      )}
                                      <div>
                                        State:{" "}
                                        {globalData?.salefrom?.state || ""} [
                                        State Code:{" "}
                                        {globalData?.salefrom?.statecode || ""}{" "}
                                        ]
                                      </div>
                                    </div>
                                  </div>
                                  {globalData?.status === "CANCELLED" && (
                                    <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                      {globalData?.status}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="tm_invoice_info tm_mb20">
                            <div
                              className="tm_invoice_seperator tm_gray_bg"
                              style={{
                                backgroundColor:
                                  selectedTheme?.templateTheme?.primaryColor,
                              }}
                            ></div>
                            <div className="tm_invoice_info_list">
                              <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                                <b className="tm_primary_color">Bill No: </b>{" "}
                                {globalData?.saleno}
                              </p>
                              <p className="tm_invoice_date tm_m0 mt-3">
                                <b className="tm_primary_color"> Date: </b>{" "}
                                {saleTime.date}
                              </p>
                            </div>
                          </div>
                          {optData?.isCustomerDisplay && (
                            <table width="100%" className="pdfcontent">
                              <tbody>
                                <tr>
                                  <td
                                    width="45%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {globalData?.saleto &&
                                      (globalData?.saleto.name ||
                                        globalData?.saleto.addressline1 ||
                                        globalData?.saleto.addressline2 ||
                                        globalData?.saleto.state ||
                                        globalData?.saleto.district ||
                                        globalData?.saleto.country ||
                                        globalData?.saleto.pincode ||
                                        globalData?.saleto.phone ||
                                        globalData?.saleto.email ||
                                        globalData?.saleto.gstnumber ||
                                        globalData?.saleto.statecode ||
                                        globalData?.saleto.referenceid) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            Bill To:
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {globalData?.saleto?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {globalData?.saleto
                                                ?.addressline1 || ""}{" "}
                                              {/* {globalData?.saleto?.addressline2 || ""}{" "} */}
                                              {globalData?.saleto?.state || ""}{" "}
                                              {globalData?.saleto?.district ||
                                                ""}{" "}
                                              {globalData?.saleto?.country ||
                                                ""}{" "}
                                              -{" "}
                                              {globalData?.saleto?.pincode ||
                                                ""}
                                            </div>
                                            {globalData?.saleto?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {globalData?.saleto?.phone}
                                              </div>
                                            )}
                                            {globalData?.saleto?.email && (
                                              <div>
                                                Email:{" "}
                                                {globalData?.saleto?.email}
                                              </div>
                                            )}
                                            {globalData?.saleto
                                              ?.referenceid && (
                                              <div>
                                                Reference No:{" "}
                                                {
                                                  globalData?.saleto
                                                    ?.referenceid
                                                }
                                              </div>
                                            )}
                                            {globalData?.saleto?.gstnumber && (
                                              <div>
                                                GST:{" "}
                                                {globalData?.saleto?.gstnumber}
                                              </div>
                                            )}
                                            {globalData.saleto?.fssai && (
                                              <div>
                                                FASSI:{" "}
                                                {globalData.saleto?.fssai}
                                              </div>
                                            )}
                                            {globalData.saleto?.cinnumber && (
                                              <div>
                                                CIN:{" "}
                                                {globalData.saleto?.cinnumber}
                                              </div>
                                            )}
                                            {globalData.saleto?.pannumber && (
                                              <div>
                                                PAN:{" "}
                                                {globalData.saleto?.pannumber}
                                              </div>
                                            )}
                                            {globalData?.saleto?.state && (
                                              <div>
                                                State:{" "}
                                                {globalData?.saleto?.state} [
                                                State Code :
                                                {globalData?.saleto
                                                  ?.statecode || ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </td>

                                  <td width="10%"></td>

                                  <td
                                    width="45%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {globalData.saleto?.shippingAddress &&
                                      (globalData.saleto?.shippingAddress
                                        ?.addressline1 ||
                                        globalData.saleto?.shippingAddress
                                          ?.addressline2) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            Shipping Address :
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {globalData.saleto?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {globalData.saleto
                                                ?.shippingAddress
                                                ?.addressline1 || ""}{" "}
                                              {/* {globalData.saleto?.shippingAddress?.addressline2 || ""}{" "} */}
                                              {globalData.saleto
                                                ?.shippingAddress?.state ||
                                                ""}{" "}
                                              {globalData.saleto
                                                ?.shippingAddress?.district ||
                                                ""}{" "}
                                              {globalData.saleto
                                                ?.shippingAddress?.country ||
                                                ""}{" "}
                                              -{" "}
                                              {globalData.saleto
                                                ?.shippingAddress?.pincode ||
                                                ""}
                                            </div>
                                            {globalData.saleto?.shippingAddress
                                              ?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {
                                                  globalData.saleto
                                                    ?.shippingAddress?.phone
                                                }
                                              </div>
                                            )}
                                            {globalData.saleto?.shippingAddress
                                              ?.email && (
                                              <div>
                                                Email:{" "}
                                                {
                                                  globalData.saleto
                                                    ?.shippingAddress?.email
                                                }
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    {/* <div>
                                    <p className="tm_invoice_number tm_m0 mb-0 mt-1">
                                      <b className="tm_primary_color">
                                        Bill No:{" "}
                                      </b>{" "}
                                      {data.saleno}
                                    </p>
                                  </div> */}
                                    {/* <div>
                                        <p className="tm_invoice_date tm_m0 mt-1">
                                        <b className="tm_primary_color">
                                            {" "}
                                            Date:{" "}
                                        </b>{" "}
                                        {saleTime.date}
                                        </p>
                                    </div> */}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )}
                          <table
                            className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Items
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Qty
                                </th>

                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {globalData?.saleitems?.map((product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "5%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "65%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    <div>{product.title}</div>
                                    {/* {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fs-12 text-truncate-description text-muted">
                                          {product?.note}
                                        </div>
                                      )} */}

                                    {/* <div>
                                      {product.hsnsac && (
                                        <span>
                                          <span className="fw-medium">
                                            HSN/SAC :{" "}
                                          </span>{" "}
                                          {product.hsnsac}
                                        </span>
                                      )}
                                      {product.discount > 0 && (
                                        <>
                                          <>
                                            {" "}
                                            <span className="fw-medium">
                                              MRP :{" "}
                                            </span>{" "}
                                            ₹
                                            {CurrencyConverter.toCurrency(
                                              product.mrp || 0,
                                              "INR"
                                            )}
                                          </>{" "}
                                          <>
                                            <span className="fw-medium">
                                              Discount :{" "}
                                            </span>{" "}
                                             ₹
                                            {CurrencyConverter.toCurrency(
                                              product.discount || 0,
                                              "INR"
                                            )}
                                          </>
                                        </>
                                      )}{" "}
                                      {product.taxpercentage > 0 && (
                                        <>
                                          <span className="fw-medium">
                                            Tax :{" "}
                                          </span>{" "}
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            product.baseprice || 0,
                                            "INR"
                                          )}
                                          @{product.taxpercentage}% = ₹
                                          {CurrencyConverter.toCurrency(
                                            product.taxamount || 0,
                                            "INR"
                                          )}
                                        </>
                                      )}
                                    </div> */}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.soldprice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode  || "";
                                      })()}
                                    </span>
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.lineTotalSoldPrice}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td
                                  colSpan={2}
                                  className="force-style"
                                  style={{
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                ></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Total
                                </td>

                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  {/* {globalData.totalqty} */}
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  ₹{globalData?.totalsoldprice}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="2"
                                >
                                  Total Amount In Words
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="2"
                                >
                                  Grand Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  ₹{globalData?.grandtotal}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    // color: "var(--th-color)",
                                    // backgroundColor:"var(--th-bg)",
                                    // "--th-color": selectedTheme?.templateTheme?.foregroundColor,
                                    // "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="2"
                                  rowSpan="5"
                                >
                                  {globalData?.amountinwords}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "var(--th-color)",
                                    backgroundColor: "var(--th-bg)",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                  colSpan="2"
                                >
                                  Grand Total (Rounded)
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "var(--th-color)",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  ₹{globalData?.grandtotal}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                    // "--th-color": `${
                                    //   selectedTheme.key === "DF"
                                    //     ? "#000000"
                                    //     : selectedTheme?.templateTheme?.primaryColor
                                    // }`,
                                    // color: "var(--th-color)",
                                  }}
                                >
                                  Your Total Discount : ₹
                                  {globalData?.totaldiscount}
                                  <br />
                                  {/* <div className="mt-1 fs-20">
                                      <span
                                      >
                                        ***** Thank You! Visit Us Again *****
                                      </span>
                                    </div> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {globalData?.grandtotal > 0 && optData?.isPayment && (
                            <table
                              className="items"
                              width="38%"
                              style={{
                                marginTop: "4px",
                                // borderCollapse: "collapse",
                              }}
                              cellPadding="4"
                            >
                              <thead>
                                <tr>
                                  <th
                                    colSpan={2}
                                    className="force-style"
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      "--th-bg":
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                      "--th-color":
                                        selectedTheme?.templateTheme
                                          ?.foregroundColor,
                                    }}
                                  >
                                    Payment Mode
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {(globalData?.cashamount || 0) -
                                  (globalData?.cashchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Cash
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.cashPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.cardamount || 0) -
                                  (globalData?.cardchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Card
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.cardPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.onlineamount || 0) -
                                  (globalData?.onlinechange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      OnlineAmount
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.onlinePaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.upiamount || 0) -
                                  (globalData?.upichange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      UPI
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.upiPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.paylateramount || 0) -
                                  (globalData?.paylaterchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      BalanceDue
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.onlinePaid}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                          <div className="row mt-2">
                            <div className="col-3 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl && optData?.isBankDetails && (
                              <div className="col-3 d-flex align-items-center justify-content-end">
                                <img
                                  src={qrCodeDataUrl}
                                  alt="QR"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="mt-2 fs-20 d-flex justify-content-center fw-bold">
                            <span>***** Thank You! Visit Us Again *****</span>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div className="mt-1 fs-20 d-flex justify-content-center fw-bold">
                                <span>Powered By</span>
                              </div>
                              <div className=" fs-20 d-flex justify-content-center fw-bold">
                                <span>www.NegoBill.com</span>
                              </div>
                            </>
                          )}
                          <table width="100%">
                            <tbody>
                              <tr>
                                {/* Left */}
                                <td
                                  width="70%"
                                  style={{
                                    verticalAlign: "top",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {optData?.isRemark && globalData?.remark ? (
                                    <>
                                      <div className="font-12 fw-600 text-black mb-1">
                                        Remark
                                      </div>

                                      <div
                                        className="font-12 mb-2 p-0"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {capitalizeFirstLetter(
                                          globalData?.remark,
                                        )}
                                      </div>
                                    </>
                                  ) : null}

                                  {terms?.length > 0 && (
                                    <>
                                      <div
                                        className="fs-13 fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>

                                      <div className="terms-box">{terms}</div>
                                    </>
                                  )}
                                </td>

                                {/* Right */}
                                <td
                                  width="30%"
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings.invoiceSettings.signature
                                      }
                                      width={150}
                                      alt="Signature"
                                    />
                                  )}

                                  <div>Issued By, Signature</div>

                                  <div className="fw-bold">
                                    {globalData?.salefrom?.title}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {/* <table
                              className="items"
                              width="100%"
                              style={{ borderCollapse: "collapse" }}
                              cellPadding="8"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      width: "52.5%",
                                      border: "0.5mm solid #e0e0e0",
                                      textAlign: "left",
                                      padding: "8px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Declaration:
                                    </span>
                                    <br />
                                    <span style={{ fontSize: "12px" }}>
                                      We declare that this bill recipet shows
                                      the actual price of the goods described
                                      and that all particulars are true and
                                      correct.
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      width: "50%",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      border: "0.5mm solid #e0e0e0",
                                      textAlign: "center",
                                      padding: "8px",
                                    }}
                                  >
                                    * Computer Generated Document No sign
                                    Required
                                  </td>
                                </tr>
                              </tbody>
                            </table> */}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="default-content">
                <p>No content available for this sale mode.</p>
              </div>
            )}
           
          </div>
        )}
        <InvoiceInfoSidebar
          {...invoiceData}
          isData={isData}
          handleSelectedReturnSale={handleSelectedReturnSale}
        />
      </InvoiceModalLayout>
      {showConfirm && (
        <Convertinvoice
          onClose={() => setShowConfirm(false)}
          onConfirm={() => handleGenerateInvoice(data)}
        />
      )}
      <PaySettleModal
        isOpen={isPaySettleModalOpen}
        data={data}
        setIsPaySettleModalOpen={setIsPaySettleModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        isBtnLoading={isBtnLoading}
        setBtnLoading={setBtnLoading}
      />
    </>
  );
};

export default EssentialInvoice;
